module.exports = __webpack_public_path__ + "img/train.84ac252e.jpg";